import { arrayRemove, arrayUnion, doc, updateDoc } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../../firebase";
import { useCallback } from "react";
import { shuffle } from "lodash";
import toast from "react-hot-toast";
import { commonAction } from "../../slices/GameSlice";
import { formatTime } from "../../App";
import { davinciCode } from "../../util/gameDefault";

const DavinciHooks = () => {
  const dispatch = useDispatch();

  const {
    davinciCode: {
      davinciCodeArr,
      davinciCodeUsers,
      turnUser,
      drawCard,
      selectCard,
    },
    drawCardLocation,
    roomId,
    submitValue,
    openCard,
    message,
  } = useSelector(state => state.GameSlice);
  const { userId, nickname } = useSelector(state => state.LoginInfoSlice);

  const JoinDavinci = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    updateDoc(docRef, {
      "davinciCode.davinciCodeUsers": arrayUnion({
        userId,
        nickname,
        cards: [],
        end: false,
        rank: 0,
      }),
    });
    // updateDoc(docRef, {
    //   "davinciCode.davinciCodeUsers": arrayUnion({
    //     userId: "test",
    //     nickname: "test",
    //     cards: [],
    //     end: false,
    //     rank: 0,
    //   }),
    // });
  }, [roomId, userId, nickname]);

  const ExitDavinci = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    const remainUsers = davinciCodeUsers.filter(i => i?.userId !== userId);

    updateDoc(docRef, {
      "davinciCode.davinciCodeUsers": remainUsers,
    });
  }, [roomId, davinciCodeUsers, userId]);

  const ResetGame = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    updateDoc(docRef, {
      davinciCode,
    });
  }, [roomId]);

  const StartDavinciCode = useCallback(() => {
    const length = davinciCodeUsers.length;
    let updateUsers = [];
    if (length < 2 || length > 4 || !length) {
      toast.error("인원이 적합하지 않습니다.");
    } else {
      for (let i = 0; i < length; i++) {
        const item = davinciCodeUsers[i];
        const keys = Object.keys(item);
        const newItem = {};
        keys.forEach(j => {
          newItem[j] = item[j];
        });
        updateUsers.push(newItem);
      }

      let davinciCards = initialDavinciArr();
      const docRef = doc(db, "game", `room${roomId}`);

      let userCards = [];

      for (let i = 0; i < length; i++) {
        userCards.push([]);
        let cardLength = i === 4 ? 3 : 4;
        userCards[i] = davinciCards.splice(0, cardLength).sort((a, b) => {
          if (a.value !== b.value) {
            return a.value - b.value;
          } else {
            if (a.color === "B" && b.color === "W") {
              return -1;
            } else if (a.color === "W" && b.color === "B") {
              return 1;
            }
          }
          return null;
        });

        for (let j = 0; j < userCards[i].length; j++) {
          if (userCards[i][j].label === "-") {
            userCards[i][j].value = null;
          }
          userCards[i][j].locationIndex = j;
        }

        updateUsers[i].cards = userCards[i];
      }
      for (let i = 0; i < davinciCards.length; i++) {
        if (davinciCards[i].label === "-") {
          davinciCards[i].value = null;
        }
      }

      const drawCard = davinciCards.splice(0, 1)[0];

      updateDoc(docRef, {
        "davinciCode.davinciCodeUsers": updateUsers,
        "davinciCode.davinciCodeArr": davinciCards,
        "davinciCode.gameStatus": true,
        "davinciCode.turnUser": updateUsers[0],
        "davinciCode.drawCard": drawCard,
      });
    }
  }, [davinciCodeUsers, roomId]);

  const CardConfirm = useCallback(() => {
    if (drawCardLocation === null) {
      toast.error("위치를 선택해주세요");
    } else {
      const currentCards = [...turnUser.cards, drawCard];
      let draw = false;
      let arr = [];

      for (let i = 0; i < currentCards.length; i++) {
        if (i === drawCardLocation) {
          const pushCard = { ...drawCard };
          pushCard.locationIndex = i;
          arr.push(pushCard);

          draw = true;
        } else {
          const pushCard = { ...currentCards[!draw ? i : i - 1] };
          pushCard.locationIndex = i;
          arr.push(pushCard);
        }
      }

      dispatch(commonAction({ target: "drawCardLocation", value: null }));

      const docRef = doc(db, "game", `room${roomId}`);
      let updateUsers = [];

      for (let i = 0; i < davinciCodeUsers.length; i++) {
        const pushUser = { ...davinciCodeUsers[i] };

        if (turnUser.userId === pushUser.userId) {
          pushUser.cards = arr;
        }
        updateUsers.push(pushUser);
      }

      updateDoc(docRef, {
        "davinciCode.davinciCodeUsers": updateUsers,
        "davinciCode.turnStep": 1,
        "davinciCode.turnUser.cards": currentCards,
      });
    }
  }, [
    dispatch,
    roomId,
    drawCardLocation,
    turnUser,
    drawCard,
    davinciCodeUsers,
  ]);

  // 턴 넘길때 카드 자동 추가 삭제
  const NextTurn = useCallback(
    updateUsers => {
      const docRef = doc(db, "game", `room${roomId}`);

      const users = updateUsers || davinciCodeUsers;
      if (users?.filter(i => i?.end)?.length >= davinciCodeUsers.length - 1) {
        updateDoc(docRef, {
          "davinciCode.turnStep": 4,
          "davinciCode.selectCard": {},
          "davinciCode.drawCard": {},
        });
      } else {
        if (davinciCodeArr.length) {
          let newUsers = [];
          const nextCard = { ...davinciCodeArr[0] };
          let currentIndex = users.findIndex(i => i.userId === turnUser.userId);
          let nextIndex = currentIndex === users.length ? 0 : currentIndex + 1;

          while (users[nextIndex] && users[nextIndex].end) {
            nextIndex += 1;
          }
          if (nextIndex === users.length) {
            nextIndex = 0;
          }
          const nextUser = users[nextIndex];
          const keys = Object.keys(nextUser);

          const newUser = {};
          const nextOrder = Math.max(...nextUser?.cards.map(j => j.order)) + 1;

          const newCard = { ...nextCard };
          newCard.order = nextOrder;
          keys.forEach(i => {
            newUser[i] = i === "cards" ? [...nextUser[i]] : nextUser[i];
          });

          users.forEach(i => {
            newUsers.push(i.userId === nextUser.userId ? newUser : i);
          });

          updateDoc(docRef, {
            "davinciCode.turnUser": newUser,
            "davinciCode.davinciCodeArr": arrayRemove(nextCard),
            "davinciCode.turnStep": 0,
            "davinciCode.davinciCodeUsers": newUsers,
            "davinciCode.selectCard": {},
            "davinciCode.drawCard": newCard,
          });
        } else {
          // 뽑을 카드가 없을 경우에 draw 카드 없이 턴만 넘김
          let currentIndex = users.findIndex(i => i.userId === turnUser.userId);
          let nextIndex = currentIndex === users.length ? 0 : currentIndex + 1;
          const nextUser = users[nextIndex];
          updateDoc(docRef, {
            "davinciCode.turnUser": nextUser,
            "davinciCode.turnStep": 0,
            "davinciCode.selectCard": {},
            "davinciCode.drawCard": {},
          });
        }
      }
    },
    [davinciCodeUsers, roomId, davinciCodeArr, turnUser]
  );

  const SubmitCard = useCallback(() => {
    if (submitValue !== null && selectCard?.label !== null) {
      const docRef = doc(db, "game", `room${roomId}`);
      const checkAnswer = selectCard.label === submitValue;

      const lastOrder = message[0]?.order + 1 || 1;
      const newMessage = {
        text: `님이 ‘${submitValue}’ 예측 → ${checkAnswer ? "성공" : "실패"}`,
        order: lastOrder,
        userId,
        nickname,
        type: "system",
        date: formatTime(new Date()),
      };

      // card => 뒤집을 카드
      let card = !checkAnswer ? drawCard : selectCard;

      let updateUsers = davinciCodeUsers.map(i => {
        let newCards = [...i.cards].map(j => ({ ...j }));
        const returnValue = { ...i };
        let findIndex = newCards.findIndex(j => {
          return j.label === card.label && j.color === card.color;
        });
        if (findIndex >= 0) {
          newCards[findIndex].reveal = true;
          if (newCards.every(j => j.reveal)) {
            returnValue.end = true;
          }
        }

        returnValue.cards = newCards;

        return returnValue;
      });

      const checkEnd =
        updateUsers?.filter(i => i?.end)?.length >= updateUsers.length - 1;

      if (checkAnswer) {
        // 정답 맞춘순간 게임 종료시 로직 추가
        updateDoc(docRef, {
          "davinciCode.davinciCodeUsers": updateUsers,
          "davinciCode.selectCard": {},
          "davinciCode.turnStep": checkEnd ? 4 : 2,
          message: arrayUnion(newMessage),
        });
        dispatch(commonAction({ target: "submitValue", value: null }));
        // 정답일 경우에 해당 카드를 reveal로 바꾸고 turnStep 이 2로 변경
      } else {
        if (!drawCard.label && !drawCard.color) {
          // 라벨도 없고 색깔도 없을떄 => 카드가 없을때
          updateDoc(docRef, {
            "davinciCode.davinciCodeUsers": updateUsers,
            "davinciCode.turnStep": 3,
            "davinciCode.selectCard": {},
            message: arrayUnion(newMessage),
          });
          dispatch(commonAction({ target: "submitValue", value: null }));
        } else {
          updateDoc(docRef, {
            "davinciCode.davinciCodeUsers": updateUsers,
            "davinciCode.selectCard": {},
            message: arrayUnion(newMessage),
          });
          NextTurn(updateUsers);
          dispatch(commonAction({ target: "submitValue", value: null }));

          // 오답일 경우에 drawCard가 reveal로 바뀌고 nextTurn이 됨
        }
      }
    } else {
      toast.error("숫자를 선택해주세요.");
    }
  }, [
    roomId,
    selectCard,
    submitValue,
    davinciCodeUsers,
    message,
    userId,
    nickname,
    drawCard,
    NextTurn,
    dispatch,
  ]);

  const OpenCard = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);
    if (openCard?.label >= 0 || (openCard?.label && openCard?.color)) {
      let updateUsers = davinciCodeUsers.map(i => {
        let newCards = [...i.cards].map(j => ({ ...j }));
        const returnValue = { ...i };
        let findIndex = newCards.findIndex(j => {
          return j.label === openCard.label && j.color === openCard.color;
        });
        if (findIndex >= 0) {
          newCards[findIndex].reveal = true;
          if (newCards.every(j => j.reveal)) {
            returnValue.end = true;
          }
        }

        returnValue.cards = newCards;

        return returnValue;
      });
      updateDoc(docRef, {
        "davinciCode.davinciCodeUsers": updateUsers,
        "davinciCode.turnStep": 0,
      });
      NextTurn(updateUsers);
      dispatch(commonAction({ target: "openCard", value: {} }));
    }
  }, [openCard, roomId, davinciCodeUsers, NextTurn, dispatch]);

  return {
    JoinDavinci,
    ExitDavinci,
    ResetGame,
    StartDavinciCode,
    CardConfirm,
    SubmitCard,
    NextTurn,
    OpenCard,
  };
};

export default DavinciHooks;
const initialDavinciArr = () => {
  // joker = -0.5~12.5
  let arr = [
    {
      label: "-",
      color: "B",
      reveal: false,
      order: 0,
      value: getRandomNumber(),
      locationIndex: null,
    },
    {
      label: "-",
      color: "W",
      reveal: false,
      order: 0,
      value: getRandomNumber(),
      locationIndex: null,
    },
  ];
  for (let i = 0; i < 12; i++) {
    arr.push({
      label: i,
      color: "B",
      reveal: false,
      order: 0,
      value: i,
      locationIndex: null,
    });
    arr.push({
      label: i,
      color: "W",
      reveal: false,
      order: 0,
      value: i,
      locationIndex: null,
    });
  }
  return shuffle(arr);
};

function getRandomNumber() {
  // 가능한 값들을 배열로 정의
  const values = [];
  for (let i = -0.5; i <= 11.5; i += 1) {
    values.push(i);
  }

  // 랜덤한 인덱스를 선택
  const randomIndex = Math.floor(Math.random() * values.length);

  // 선택된 인덱스에 해당하는 값을 반환
  return values[randomIndex];
}
